export const ADMIN_EMAIL = 'b910925123@gmail.com';
export const STAFF_EMAIL = 'staff@barcode-1b39e.firebaseapp.com';

const normalizeEmail = (email) => String(email || '').trim().toLowerCase();

export const isAdminUser = (user) => (
  normalizeEmail(user?.email) === ADMIN_EMAIL
  && user?.emailVerified === true
  && (user?.providerData || []).some((provider) => provider?.providerId === 'google.com')
);

export const getAuthorizedUserRole = async (user, forceRefresh = false) => {
  if (!user) return null;
  if (isAdminUser(user)) return 'admin';

  if (normalizeEmail(user.email) !== STAFF_EMAIL) return null;
  const tokenResult = await user.getIdTokenResult(forceRefresh);
  return tokenResult.claims?.role === 'staff' ? 'staff' : null;
};
